import BasicModal from './BasicModal.js';
import Alert from './Alert.js';
import './index.scss';

//
//  index.js
//  <project>
//  改造antd的Modal为我们需要的样式
//  Created by licheng09 on 2017-10-28.
//  Copyright 2017 licheng09. All rights reserved.
//

export { BasicModal, Alert };




// WEBPACK FOOTER //
// ./src/components_common/Modal/index.js